import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhotoBgDirective } from './directives/photo-bg.directive';
import { BlinkDirective } from './directives/blink.directive';
import { DynamicColDirective } from './directives/dynamic-col.directive';
import { DynamicKbFrameDirective } from './directives/dynamic-kb-frame.directive';
import { MyFocusDirective } from './directives/my-focus.directive';
import { NgInitDirective } from './directives/ng-init.directive';
import { SwipeVerticalDirective } from './directives/swipe-vertical.directive';
import { LinkIntereptorDirective } from './directives/link-interceptor';
import { InnerContentDirective } from './directives/inner-content';
import { Autosize } from './directives/autosize.directive';
import { DebounceClickDirective } from './directives/debounce-click.directive';
import { HideHeaderDirective } from './directives/hide-header.directive';
import { EnterKeyPressDirective } from './directives/enter-key-press.directive';
import { InteractiveImageWrapperDirective } from './directives/interactive-wrapper.directive';

const components = [
  Autosize,
  PhotoBgDirective,
  BlinkDirective,
  DebounceClickDirective,
  DynamicColDirective,
  DynamicKbFrameDirective,
  EnterKeyPressDirective,
  HideHeaderDirective,
  InnerContentDirective,
  InteractiveImageWrapperDirective,
  LinkIntereptorDirective,
  MyFocusDirective,
  NgInitDirective,
  SwipeVerticalDirective
];

@NgModule({
  declarations: [...components],
  imports: [
    CommonModule
  ],
  exports: [...components]
})
export class DirectivesModule { }
